







import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class SortIndicator extends Vue {
	@Prop()
	public reverse!: boolean;
}
